import React from 'react'

export default function MapEmbed() {
    const mapSrc = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3570.1234567890123!2d45.987654321!3d26.123456789012345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fd740ac5200fc2d%3A0x7a460a9890985a39!2sDr.%20Noor%20Mohammed%20Khan%20General%20Hospital!5e0!3m2!1sen!2ssa!4v1234567890123!5m2!1sen!2ssa`;



    return (
        <div style={{ width: '100%', height: '400px' }}>
          <iframe
            title="Dr. Noor Mohammed Khan General Hospital"
            src={mapSrc}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          />
        </div>
      );
}
